import { BASE_PRE_ORDER_PATH } from '../paths';

export const BASE_COVID_PRE_ORDER_PATH = `${BASE_PRE_ORDER_PATH}/covid`;
